import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../../../../assests/css/admin/DisputeManagement/DisputeManagement.css';
import DisputeCards  from '../../../../components/Admin/DisputeManagement/DisputerCards/DisputeCards';
import DisputeList   from '../../../../components/Admin/DisputeManagement/DisputeList/DisputeList';
import DisputeDetail from '../../../../components/Admin/DisputeManagement/DisputeDetail/DisputeDetail';
import AppContext    from '../../../../context/AppContext';

const DisputeManagement = () => {
  const { baseUrl } = useContext(AppContext);

  const [selectedDispute, setSelectedDispute] = useState(null);
  const [disputes, setDisputes]               = useState([]);
  const [loading, setLoading]                 = useState(false);
  const [stats, setStats] = useState({
    totalOpen:    { value: 0, change: '', isPositive: true  },
    pendingAdmin: { value: 0, change: '', isPositive: true  },
    resolved:     { value: 0, change: '', isPositive: false },
    escalated:    { value: 0, change: '', isPositive: false },
  });

  const computeStats = (tickets) => {
    setStats({
      totalOpen:    { value: tickets.filter((t) => t.status?.toLowerCase() === 'open').length,      change: '', isPositive: true  },
      pendingAdmin: { value: tickets.filter((t) => t.status?.toLowerCase() === 'pending').length,   change: '', isPositive: true  },
      resolved:     { value: tickets.filter((t) => t.status?.toLowerCase() === 'closed').length,    change: '', isPositive: false },
      escalated:    { value: tickets.filter((t) => t.status?.toLowerCase() === 'escalated').length, change: '', isPositive: false },
    });
  };

  const viewAllHelpsupport = () => {
    if (!baseUrl) return;
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/HelpandSupport/viewAllHelpsupport`)
      .then((response) => {
        if (response.data.success) {
          const allTickets = response.data.tickets || [];
          setDisputes(allTickets);
          computeStats(allTickets);
        } else {
          Swal.fire({
            icon:  'error',
            title: 'Failed',
            text:  response.data.message || 'Could not load tickets',
          });
        }
      })
      .catch((error) => {
        console.error('viewAllHelpsupport error:', error);
        Swal.fire({
          icon:  'error',
          title: 'Server Error',
          text:  error.response?.data?.message || 'Failed to load disputes',
        });
        setDisputes([]);
      })
      .finally(() => setLoading(false));
  };

  // Re-runs only when baseUrl is available
  useEffect(() => {
    viewAllHelpsupport();
  }, [baseUrl]);

  const updateStatus = (ticketId, newStatus) => {
    axios
      .post(`${baseUrl}/admin/HelpandSupport/updateStatus`, {
        ticket_id: ticketId,
        status:    newStatus,
      })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({
            icon:              'success',
            title:             'Status Updated!',
            text:              `Ticket status changed to "${newStatus}"`,
            timer:             1500,
            showConfirmButton: false,
          });

          const updatedDisputes = disputes.map((d) =>
            d.id === ticketId ? { ...d, status: newStatus } : d
          );
          setDisputes(updatedDisputes);
          computeStats(updatedDisputes);

          if (selectedDispute?.id === ticketId) {
            setSelectedDispute((prev) => ({ ...prev, status: newStatus }));
          }
        } else {
          Swal.fire({
            icon:               'error',
            title:              'Update Failed',
            text:               response.data.message || 'Status update failed',
            confirmButtonColor: '#ef4444',
          });
        }
      })
      .catch((error) => {
        console.error('updateStatus error:', error);
        Swal.fire({
          icon:               'error',
          title:              'Oops!',
          text:               error.response?.data?.message || 'Something went wrong, please try again',
          confirmButtonColor: '#ef4444',
        });
      });
  };

  const handleViewDetails = (dispute) => setSelectedDispute(dispute);
  const handleBackToList  = () => {
    setSelectedDispute(null);
    viewAllHelpsupport();
  };

  return (
    <div className="Dispute-Admin-Dispute-container">
      {!selectedDispute ? (
        <>
          <div className="Dispute-Admin-Dispute-header">
            <h1 className="Dispute-Admin-Dispute-title">Dispute Management</h1>
            <p className="Dispute-Admin-Dispute-subtitle">
              Review, investigate, and resolve customer conflict requests across all store categories.
            </p>
          </div>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '20px' }}>Loading disputes...</p>
          ) : (
            <>
              <DisputeCards stats={stats} />
              <DisputeList
                disputes={disputes}
                onViewDetails={handleViewDetails}
                onUpdateStatus={updateStatus}
              />
            </>
          )}
        </>
      ) : (
        <DisputeDetail
          dispute={selectedDispute}
          onBack={handleBackToList}
          onUpdateStatus={updateStatus}
        />
      )}
    </div>
  );
};

export default DisputeManagement;